import { Component, OnInit, Renderer } from '@angular/core';
import { Pregunta, Respuesta, RespuestaTipoOpciones } from './cuestionario.entity';
import { NavegacionService, PresentacionOk } from '../sidenav.service';
import { Dimension } from '../solucion/Dimension.entity';
import { Capa } from '../solucion/Capa.entity';
import { Etapa } from '../diagnostico/Diagnostico.entity';
import { CuestionarioHttpServicesService } from '../cuestionario-http-services.service';
import { LoaderService } from '../loader.service';
import { User } from '../shared/user.model';
import { UserService } from '../shared/user.service';
import { ToastrService } from 'ngx-toastr';
import { ThemePalette } from '@angular/material';

@Component({
  selector: 'app-cuestionario',
  templateUrl: './cuestionario.component.html',
  styleUrls: ['./cuestionario.component.css'] // , '../../assets/scss/tool-styles.scss']
})
export class CuestionarioComponent implements OnInit {

  public _dimensiones: Dimension[];
  public _etapas: Etapa[];
  public _preguntas: Pregunta[];
  public presentacion: PresentacionOk ;
  public currentClient: User = null;
  // public currentEtapa: Etapa = null;
  public _preguntasFiltered: Pregunta[] = null;
  // public currentDimension: Dimension = null;
  public currentCapa: Capa = null;
  public indexSeleccion: number = null;
  public esCambioCiclo: Boolean = false;
  public _respuestas: Respuesta[];
  public _respuestasOpciones: RespuestaTipoOpciones[];
  public loaded = false;
  public continuar = false;

  constructor( public _sidenav: NavegacionService,
               private loaderService: LoaderService,
               private _cuestionarioServices: CuestionarioHttpServicesService, // PD
               private toastr: ToastrService,
               public userService: UserService  ) {
                this.presentacion = new PresentacionOk();
                // console.log(this._sidenav.presentacion);
                // if (this._sidenav.presentacion !== undefined &&  this._sidenav.presentacion.ok) {
                //  this.presentacion.ok = true;
                // } else {
                //  this.presentacion.ok = false;
                // }
                // this._sidenav.setpresentacion(this.presentacion);
                // alert(''ntacion'');
                // console.log('Constructor de cuestionario');
                }
  ngOnInit() {
    // this.currentClient = this._sidenav.currentClient;
   //  this.userService.getUserClaims().subscribe((data: any) => {
   //  this.currentClient = data;
    this.currentClient = this._sidenav.currentClient;
    // console.log('cuestionario on init! ');
    // console.log(this.currentClient);
    const diag = this._sidenav.currentDiag;
    // console.log('en cuestionario on init: ', this.currentClient);
    this.loaderService.display(true);
    this._cuestionarioServices.getDimension().subscribe( objarray => {
    this._cuestionarioServices.getEtapa().subscribe( objEtapa => {
    this._cuestionarioServices.getPreguntas().subscribe( objPreguntas => {
    this._cuestionarioServices.getRespuestas(diag.diagnosticoID).subscribe( objRespuestas => {
    this._cuestionarioServices.getRespuestaTipoOpciones().subscribe( objRespuestasTO => {
      this._etapas = objEtapa;
      this._dimensiones = objarray;
      this._preguntas = objPreguntas;
      this._respuestas = objRespuestas;
      this._respuestasOpciones = objRespuestasTO;
      const currEtapa = this._sidenav.currentEtapa;
      if (currEtapa === undefined ) {
        this._sidenav.currentEtapa =  this._etapas[0];
      }
      this.loaded = true;
      this.loaderService.display(false);
      if (this._respuestas.length > 1 ) {
          this.presentacion.ok = true;
        }
      // this.gotoTop();
    });
    });
    });
  });
});
// });
 }
 GetPreguntas(): Pregunta[] {
  let currEtapa =  this._sidenav.currentEtapa;
  if ( currEtapa === null || currEtapa === undefined) {
    this._sidenav.currentEtapa =  this._etapas[0];
    currEtapa = this._etapas[0];
  }
  if ( currEtapa != null && currEtapa.etapaId !== 3) {
    return this.GetbyEtapa( this._sidenav.currentEtapa.etapaId);
  } else {
    const currDim = this._sidenav.currentDimension;
    if ( currDim != null && currEtapa.etapaId === 3 ) {
        return this.GetbyDimension( currDim.dimensionID);
      } else {
        return this.GetbyDimension( this._dimensiones[0].dimensionID );
      }
  }
 }
GetRespuestaAsociada(preguntaID: number, deOption?: boolean): string {
  // console.log('Get Respuesta' , preguntaID);
  let respuestaValue = '';
  const resp = this.GetRespuesta(preguntaID);
  if (resp != null) {
    respuestaValue = this.GetRespuesta(preguntaID).valor;
  // console.log(respuestaValue);
  if (resp.respuestaTipoID === 2 && resp.respuestaTipoOpcionID === 7) {
    this.esCambioCiclo = true;
  }
  // else {
  //  this.esCambioCiclo = false;
  // }
  if (resp.respuestaTipoID !== undefined && resp.respuestaTipoID === 3) {
    if (deOption !== undefined && deOption	) {
      // Opcion De:.....
      respuestaValue = respuestaValue.substring(3, respuestaValue.indexOf('Hacia:') - 1 );
    } else {
      // Opcion Hacia :.....
      respuestaValue = respuestaValue.substring(respuestaValue.indexOf('Hacia:') + 6 );
    }
  }
  }
  return respuestaValue ;
}

setRespuestaId(preguntaID: number,  id: number): void {
  // console.log('set', preguntaID, value );
  const pr = this.Get(preguntaID);
  // console.log('respuesta tipo ', pr.respuestaTipoID );
  const ropt = this._respuestasOpciones.filter(x => x.respuestaTipoOpcionID === id)[0];
  // console.log(pr.respuestaTipoID);
  // console.log(ropt.respuestaTipoOpcionID);
  if (pr.respuestaTipoID === 2 && ropt.respuestaTipoOpcionID === 7) {
    this.esCambioCiclo = true;
  } else {
    this.esCambioCiclo = false;
  }
  // console.log('respuesta opcion', ropt);
  let resp: Respuesta;
  if (this._respuestas != null) {
    const index = this._respuestas.findIndex(item => item.preguntasID === preguntaID);
    if (index > -1) {
      resp =  this._respuestas[index];
      resp.valor = ropt.respuestaOpcion;
      resp.respuestaTipoOpcionID = ropt.respuestaTipoOpcionID;
      this._cuestionarioServices.UpdateRespuesta(resp).subscribe(
        obj => {
          this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
            objRespuestas => {
                  this._respuestas = objRespuestas;
          });
        });
    } else {
      resp = new Respuesta(null,
        this.currentClient,
        this.currentClient.clienteID,
        pr.respuestaTipoID,
        ropt.respuestaTipoOpcionID,
        ropt,
        pr,
        pr.preguntasID,
        this._sidenav.currentEtapa,
        this._sidenav.currentEtapa.etapaId,
        this._sidenav.currentDiag.diagnosticoID,
        ropt.respuestaOpcion);
        this._cuestionarioServices.AddRespuesta(resp).subscribe(
            obj => {
              this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
                objRespuestas => {
                      this._respuestas = objRespuestas;
              });
            });
        // this._respuestas.push(resp);
      }
  } else {
    resp = new Respuesta(null,
      this.currentClient,
      this.currentClient.clienteID,
      pr.respuestaTipoID,
      ropt.respuestaTipoOpcionID,
      ropt,
      pr,
      pr.preguntasID,
      this._sidenav.currentEtapa,
      this._sidenav.currentEtapa.etapaId,
      this._sidenav.currentDiag.diagnosticoID,
      ropt.respuestaOpcion);

      this._cuestionarioServices.AddRespuesta(resp).subscribe(
        obj => {
          this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
            objRespuestas => {
                  this._respuestas = objRespuestas;
          });
        });
      // this._respuestas.push(resp);
    }
  }

  setRespuesta(preguntaID: number,   value: string): void {
    // console.log('set', preguntaID, value );
    const pr = this.Get(preguntaID);
    // console.log('respuesta tipo ', pr.respuestaTipoID );
    const ropt = this._respuestasOpciones.filter(x => x.respuestaOpcion === 'De')[0];
    // console.log(pr.respuestaTipoID);
    // console.log(value);
    if (pr.respuestaTipoID === 3) {
      const elemAsociadoDe = <HTMLInputElement>document.getElementById(pr.preguntasID + 'De');
      const elemAsociadoHacia = <HTMLInputElement>document.getElementById(pr.preguntasID + 'Hacia');
      // console.log('elemento asociado', elemAsociadoDe.value , elemAsociadoHacia.value  );
      value = 'De: ' + elemAsociadoDe.value + ' Hacia: ' + elemAsociadoHacia.value;
      // console.log(value);
    }
    let resp: Respuesta;
    if (this._respuestas != null) {
      const index = this._respuestas.findIndex(item => item.preguntasID === preguntaID);
      if (index > -1) {
        resp =  this._respuestas[index];
        resp.valor = value;
        this._cuestionarioServices.UpdateRespuesta(resp).subscribe(
          obj => {
            this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
              objRespuestas => {
                    this._respuestas = objRespuestas;
            });
          });
      } else {
        resp = new Respuesta(null,
          this.currentClient,
          this.currentClient.clienteID,
          pr.respuestaTipoID,
          ropt.respuestaTipoOpcionID,
          ropt,
          pr,
          pr.preguntasID,
          this._sidenav.currentEtapa,
          this._sidenav.currentEtapa.etapaId,
          this._sidenav.currentDiag.diagnosticoID,
          value);
          this._cuestionarioServices.AddRespuesta(resp).subscribe(
              obj => {
                this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
                  objRespuestas => {
                        this._respuestas = objRespuestas;
                });
              });
          // this._respuestas.push(resp);
        }
    } else {
      resp = new Respuesta(null,
        this.currentClient,
        this.currentClient.clienteID,
        pr.respuestaTipoID,
        ropt.respuestaTipoOpcionID,
        ropt,
        pr,
        pr.preguntasID,
        this._sidenav.currentEtapa,
        this._sidenav.currentEtapa.etapaId,
        this._sidenav.currentDiag.diagnosticoID,
        value);

        this._cuestionarioServices.AddRespuesta(resp).subscribe(
          obj => {
            this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
              objRespuestas => {
                    this._respuestas = objRespuestas;
            });
          });
        // this._respuestas.push(resp);
      }
    }
setInputFocus( i: number): void {
  this.indexSeleccion = i;
}
  Empezar() {
    // console.log('En empezar cuestionario.');
    // alert( this.loaded);
    // this._sidenav.presentacionok(true);
    this.presentacion.ok = true;
    // alert(this._etapas);
    if ( this.loaded ) {
    this._sidenav.currentEtapa =  this._etapas[0];
    }
    // console.log('En el empezar seteo ', this.GetPreguntas());
    // this.setEtapa();
    // alert('Al finalizar el set dimension');
    // console.log('En empezar cuestionario despues de set dimension.');
  }
  Continuar() {
    // Controlar las respuestas de la seccion, tengas todas las respuestas.
    let todasrespuestas = true;
    this.GetPreguntas().forEach(element => {
      if ( !this.estaCompletaPregunta(element.preguntasID)) {
        todasrespuestas = false;
      }
    });
    if (todasrespuestas) {
        const etapa = this._etapas.find(x => x.etapaId === this._sidenav.currentEtapa.etapaId);
        if (!etapa) {
            etapa.isCompleted = true;
        }
        this._sidenav.setEtapa();
        if (this._sidenav.currentEtapa.etapaId === 2 && !this.esCambioCiclo) {
          this._sidenav.setEtapa();
        }
        if ( this._sidenav.currentEtapa.etapaId === 2) {
          // Etapa de cambio que aparezca por defecto el primer item seleccionado.
          this.indexSeleccion = 0;
        }
        this.continuar = true;
  } else {
    this.toastr.error('Necesitamos que respondas todas las preguntas.');
  }
}
  gotoTop() {
    const element = document.getElementById('scrollId');
    // element.scrollIntoView();
    // console.log(element);
    element.scrollTop = 0 ; // element.scrollHeight;
    this.continuar = false;
    // alert(this.continuar);
  }

  Cancelar() {
    this.toastr.success('Listo, podrás retomarlo cuando quieras desde tus \'Diagnósticos\'');
    this._sidenav.irDiagnostico();
  }
GetbyEtapa(etapaID: number): Pregunta[] {
  // console.log(etapaID);
  return this._preguntas.filter( a => a.etapaID === etapaID);
}
GetbyDimension(dimensionID: number): Pregunta[] {
  if (this._preguntas !== null && this._preguntas !== undefined) {
      return this._preguntas
              .filter( a => a.dimensionID === dimensionID);
  }
  }

Get(id: number): Pregunta {
  const preguntas: Pregunta[] = this._preguntas;
  const  index = preguntas.findIndex( (a) => a.preguntasID === id);
  if (index < 0) {
    return null;
  }
  return preguntas[index];
}

GetRespuesta(id: number): Respuesta {
  let result: Respuesta = null;
  if (this._respuestas != null) {
      // alert(id);
      const  index = this._respuestas.findIndex( (a) => a.preguntasID === id);
      // alert(index);
      if (index < 0) {
        result = null;
      }
      result = this._respuestas[index];
    }
    return result;
}
GetRespuestaTipoOpciones(respuestaTipoID: number): RespuestaTipoOpciones[] {
  // console.log('GetRespuestaTipoOpciones' , respuestaTipoID);
  return this._respuestasOpciones.filter( (a) => a.respuestaTipoID === respuestaTipoID);
}
GetRespuestaTipoOpcion(respuestaTipoOpcionID: number): string {
  // console.log('GetRespuestaTipoOpciones' , respuestaTipoID);
  return this._respuestasOpciones.filter( (a) => a.respuestaTipoOpcionID === respuestaTipoOpcionID)[0].respuestaOpcion;
}
GetRespuestaAsociadaId(preguntaID: number, deOption?: boolean): number {
  // console.log('Get Respuesta' , preguntaID);
  let respuestaValue = 0;
  const resp = this.GetRespuesta(preguntaID);
  if (resp != null) {
    respuestaValue = this.GetRespuesta(preguntaID).respuestaTipoOpcionID;
  // console.log(respuestaValue);
  }
  return respuestaValue ;
}
estaCompletaPregunta(preguntaID: number): boolean {
  const resp = this.GetRespuesta(preguntaID);
  return (resp != null);
  }


}






// WEBPACK FOOTER //
// ./src/app/cuestionario/cuestionario.component.ts